import {Component, Input, OnInit} from '@angular/core';
import {PageChangeEvent, RemoveEvent} from "@progress/kendo-angular-grid";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {CadInsumoComponent} from "../cad-insumo/cad-insumo.component";
import {EstoqueService} from "../../services/estoque.service";

@Component({
  selector: 'app-listagem-insumos',
  templateUrl: './listagem-insumos.component.html',
  styleUrls: ['./listagem-insumos.component.scss']
})
export class ListagemInsumosComponent implements OnInit {
  @Input() grupos: any = [];
  @Input() insumos: any = [];
  @Input() carregando = false;
  insumosPorGrupo = [];
  insumosFiltrados: any[] = [];
  filtroTexto = '';
  grupoFiltroId: number = null;
  pageSize = 20;
  pageSizes: any = [10, 20, 30, 40, 50, 100]
  skip = 0;
  itemSelecionado: any;
  excluindo: boolean;
  abraDialogo: boolean;
  mensagemRemocao: string
  constructor(private estoqueService: EstoqueService,
              private dialogService: DialogService) { }

  ngOnInit(): void {
    this.apliqueFiltros();
  }

  setInsumos(insumos: any){
    this.insumos  = insumos;
    this.apliqueFiltros();
    this.carregando = false;
  }

  apliqueFiltros(): void {
    const texto = this.normalizeTexto(this.filtroTexto);
    this.insumosFiltrados = (this.insumos || []).filter((insumo: any) => {
      const grupoId = insumo.grupo ? Number(insumo.grupo.id) : -1;
      const correspondeAoGrupo = this.grupoFiltroId === null ||
        this.grupoFiltroId === undefined || grupoId === Number(this.grupoFiltroId);
      const dadosParaBusca = this.normalizeTexto(`${insumo.nome || ''} ${insumo.codigo || ''}`);
      return correspondeAoGrupo && (!texto || dadosParaBusca.includes(texto));
    });
    this.insumosPorGrupo = this.agruparPorGrupo(this.insumosFiltrados);
    this.skip = 0;
  }

  filtrePorTexto(texto: string): void {
    this.filtroTexto = texto || '';
    this.apliqueFiltros();
  }

  filtrePorGrupo(grupoId: number): void {
    this.grupoFiltroId = grupoId;
    this.apliqueFiltros();
  }

  limpeFiltros(): void {
    this.filtroTexto = '';
    this.grupoFiltroId = null;
    this.apliqueFiltros();
  }

  possuiFiltro(): boolean {
    return !!this.filtroTexto ||
      (this.grupoFiltroId !== null && this.grupoFiltroId !== undefined);
  }

  private normalizeTexto(valor: any): string {
    return String(valor || '').trim().toLocaleLowerCase('pt-BR')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  abraModalMovimentacoes(insumo: any){
    this.abraModalInsumo(insumo, 4);
  }

  editarInsumo(row: any) {
    this.abraModalInsumo(row.dataItem)
  }

  mudouPaginacao($event: PageChangeEvent) {
    this.pageSize = $event.take;

  }

  abraModalVincularInsumo(insumo: any){
    this.abraModalInsumo(insumo, 3);
  }


  abraDialogRemoverInsumo($event: RemoveEvent){
    this.itemSelecionado = $event.dataItem;
    this.abraDialogo = true;
  }


  removaInsumo(){
    this.excluindo = true;

    this.estoqueService.removaInsumo(this.itemSelecionado).then(() => {
      this.excluindo = false;
      this.itemSelecionado.removido = true;
      this.fecheRemover();
    }).catch((err) => {
      this.excluindo = false;
      this.mensagemRemocao = err;
    });

  }

  // Função para agrupar insumos por grupo
  agruparPorGrupo = (insumos: any[]) => {
    return insumos.reduce((acc, insumo) => {
      const grupoId = insumo.grupo ? insumo.grupo.id : -1;

      if (!acc[grupoId])
        acc[grupoId] = []; // Se o grupo ainda não existe, cria um array para ele


      acc[grupoId].push(insumo); // Adiciona o insumo ao grupo

      return acc;
    }, {} as Record<number, any[]>); // Inicializa como um objeto vazio
  };

  abraModalInsumo(insumo: any, aba: number = null) {
    CadInsumoComponent.abraModalInsumo(this.dialogService, this.grupos, insumo, aba, null, (result: any) => {

    })
  }

  beneficiado(item: any){
    return item.tipo === 'produto-beneficiado'
  }

  possuiDadosFinanceiros(item: any): boolean {
    return !!item.estoque && item.estoque.custoConhecido !== undefined;
  }

  possuiAlgumDadoFinanceiro(itens: any[]): boolean {
    return (itens || []).some(item => this.possuiDadosFinanceiros(item));
  }

  valorDosItensExibidos(itens: any[]): number {
    return (itens || []).reduce((total, item) => {
      const valor = item.estoque && item.estoque.valorFisico;
      return valor == null ? total : total + Number(valor);
    }, 0);
  }

  possuiCustoDesconhecido(itens: any[]): boolean {
    return (itens || []).some(item => this.possuiDadosFinanceiros(item) && !item.estoque.custoConhecido);
  }


  fecheRemover(){
    delete  this.mensagemRemocao;
    delete  this.itemSelecionado;
    this.abraDialogo = false;
  }

}
